import { useCallback, useEffect, useRef, useState } from "react";
import { Search } from "react-feather";
import { MdDeleteForever } from "react-icons/md";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { countHeaders } from "../../api/finance/creditDebitNoteApi";
import {
  evInvApprovalSearch,
  evInvDelete,
  getAdHocInvoiceById,
} from "../../api/finance/invoiceSearchApi";
import Grid from "../../components/Grid";
import LoadingSpinner from "../../components/LoadingSpinner";
import Tab from "../../components/Tab";
import EvInvApprovalSearchComponent from "../../components/finance/EvInvApprovalSearchComponent";
import CustomAlert from "../../components/input/CustomAlert";
import SideDrawer from "../../components/input/SideDrawer";
import ButtonRenderer from "../../components/renderer/ButtonRenderer";
import MultiValueSelectRenderer from "../../components/renderer/MultiValueSelectRenderer";
import {
  ActiveCellStyle,
  CurrencyRenderer,
  ResizableScrollingTextRenderer,
  StatusCellStyle,
} from "../../components/renderer/StyleRenderer";
import { FORMS, MODULES } from "../../const";
import useUserCompany from "../../hooks/useUserCompany";
import JobMonitorEvInvCreation from "./JobMonitorEvInvCreation";

const mode = {
  EV: 3,
  INV: 4,
};

const EvInvApproval = () => {
  const [tab, setTab] = useState(1);
  const [activeAccordion1, setActiveAccordion1] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [searchClicked, setSearchClicked] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const gridRef = useRef();
  const [resetClicked, setResetClicked] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [approvalMode, setApprovalMode] = useState(false);
  const [eihCode, setEihCode] = useState("");
  const [eihId, setEihId] = useState("");
  const deleteRef = useRef();
  const [jobId, setJobId] = useState("");
  const [evInvCategory, setEvInvCategory] = useState("");
  const [invoiceDetails, setInvoiceDetails] = useState({});
  const [isBlurred, setIsBlurred] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [updateNeeded, setUpdateNeeded] = useState(false);
  const user = useSelector((state) => state.user);
  const userCompany = useUserCompany();
  const [company, setCompany] = useState(
    userCompany ? userCompany.comId : null
  );
  useEffect(() => {
    setCompany(userCompany ? userCompany.comId : null);
  }, [userCompany]);
  const auth = useSelector((state) => state.user.permissions[MODULES.Finance]);
  const evInvApprovalPermission = auth[FORMS?.EV_INV_APPROVAL?.HEADER?.form];
  const evInvDeletePermission = evInvApprovalPermission?.FORM?.DELETE;

  const handleAccordionClick1 = () => {
    setActiveAccordion1(!activeAccordion1);
  };

  const handleSearchEv = useCallback(async (data) => {
    setActiveAccordion1(false);
    setIsLoading(true);
    setSearchClicked(true);
    const result = await evInvApprovalSearch(data);

    const evInvList = [];
    for (let jobDetail of result) {
      const formater = jobDetail.currency
        ? Intl.NumberFormat("en-US", {
            style: "currency",
            currency: jobDetail.currency,
          })
        : null;

      evInvList.push({
        ...jobDetail,
        customer:
          jobDetail.eihsingle_bulk === 1
            ? jobDetail.customer
            : jobDetail.eihtype === 1
              ? jobDetail.customer
              : "N/A",
        transporter:
          jobDetail.eihsingle_bulk === 1
            ? jobDetail.transporter
            : jobDetail.eihtype === 2
              ? jobDetail.transporter
              : "N/A",
        createdFormatDate: jobDetail.createddate.split("T")[0],
        formatter: formater,
      });
    }

    setSearchResults(evInvList);
    setIsLoading(false);
  }, []);

  console.log("search results", searchResults);

  useEffect(() => {
    setSearchClicked(false);
    setActiveAccordion1(true);
  }, [resetClicked]);

  const cellDoubleClickHandler = async (params) => {
    setIsBlurred(true);
    const invoiceById = await getAdHocInvoiceById(params.data.eihid);
    console.log("invoiceById: ", invoiceById);
    setInvoiceDetails(invoiceById);
    setEihCode(params.data.eihcode);
    setJobId(params.data.eihjob_id);
    setEvInvCategory(params.data.eihtype === 2 ? 3 : 4);
    setApprovalMode(true);
    setIsDrawerOpen(true);
    setIsBlurred(false);
  };

  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
    setApprovalMode(false);
    setInvoiceDetails({});
    setEihCode("");
    setJobId("");
    setEvInvCategory("");
  };

  const handleDelete = async (eihId, type, auth, com) => {
    setIsDeleting(true);
    const res = await evInvDelete({
      eihId: eihId,
      type: type,
      author: auth,
      company: com,
    });

    if (res?.status === 200) {
      toast.success(`${res.data} deleted successfully`, {
        autoClose: 5000,
        containerId: "Main",
      });
      setUpdateNeeded(true);
    } else {
      toast.error(res.data, {
        autoClose: 5000,
        containerId: "Main",
      });
    }
    setIsDeleting(false);
  };

  return (
    <div>
      {isBlurred && (
        <div className="blur-overlay">
          <LoadingSpinner message={`Loading...`} />
        </div>
      )}
      {isDeleting && (
        <div className="blur-overlay">
          <LoadingSpinner message={`Deleting ${eihCode}...`} />
        </div>
      )}
      <CustomAlert
        ref={deleteRef}
        message={`Are you sure you want to delete ${eihCode}?`}
        onAccept={() => {
          handleDelete(eihId, 1, user.username, company);
        }}
      />

      {evInvApprovalPermission && (
        <div className="ui tabular menu top attached">
          <Tab
            Icon={Search}
            onClick={() => {
              setTab(1);
            }}
            active={tab === 1}
            label="Search EV/INV"
          />
        </div>
      )}

      {evInvApprovalPermission ? (
        <div
          className="ui bottom attached active tab segment"
          style={{ display: tab === 1 ? "block" : "none", width: "100%" }}
        >
          <div
            class="ui styled accordion"
            style={{ width: "100%", marginBottom: "10px" }}
          >
            <div
              className={`title ${activeAccordion1 ? "active" : ""}`}
              onClick={() => handleAccordionClick1(!activeAccordion1)}
            >
              <div>
                Click here to expand search
                <Search size={14} style={{ marginLeft: "10px" }} />
                <i class="dropdown icon"></i>
              </div>
            </div>
            <div className={`content ${activeAccordion1 ? "active" : ""}`}>
              <EvInvApprovalSearchComponent
                searchResHandler={handleSearchEv}
                setResetClicked={setResetClicked}
                updateNeeded={updateNeeded}
                setUpdateNeeded={setUpdateNeeded}
              />
            </div>
          </div>

          {searchClicked && (
            <>
              {isLoading ? (
                <LoadingSpinner />
              ) : (
                <Grid
                  ref={gridRef}
                  wrapText={false}
                  multiRowSelection={false}
                  isLoading={isLoading}
                  searchable={false}
                  config={[
                    {
                      headerName: "EV/INV Code",
                      field: "eihcode",
                      headerCheckboxSelection: true,
                      checkBoxSelection: true,
                      pinned: "left",
                      minWidth: 150,
                      width: 150,
                      filter: true,
                    },
                    {
                      headerName: "Single Or Bulk",
                      field: "eihsingle_bulk_desc",
                    },
                    { headerName: "Type name", field: "eihtype_name" },
                    { headerName: "EV Or INV", field: "ceihtype" },
                    {
                      headerName: "Job Code",
                      field: "eihjob_no",
                      cellRenderer: MultiValueSelectRenderer,
                    },
                    {
                      headerName: "Amount",
                      field: "eihwith_tax",
                      cellRenderer: CurrencyRenderer,
                      cellRendererParams: (params) => ({
                        formatter: params.data.formatter,
                      }),
                    },
                    {
                      headerName: "Amount Without Tax",
                      field: "eihwithout_tax",
                      cellRenderer: CurrencyRenderer,
                      cellRendererParams: (params) => ({
                        formatter: params.data.formatter,
                      }),
                    },
                    {
                      headerName: "Customer",
                      field: "customer",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Transporter",
                      field: "transporter",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Container Nos",
                      field: "container_nos",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Status",
                      field: "eihstatus_name",
                      cellRenderer: StatusCellStyle,
                      // pinned: "right",
                      width: "120",
                      minWidth: "120",
                    },
                    {
                      headerName: "Active",
                      field: "eihactive_namet",
                      cellRenderer: ActiveCellStyle,
                      pinned: "right",
                      width: "120",
                      minWidth: "120",
                    },
                    {
                      headerName: "Created Date",
                      field: "createdFormatDate",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    { headerName: "Created By", field: "createdby" },
                    {
                      field: "delete",
                      cellRenderer: ButtonRenderer,
                      pinned: "right",
                      width: "90",
                      minWidth: "90",
                      cellRendererParams: (params) => {
                        console.log(params);
                        return {
                          clickHandler: async () => {
                            const res = await countHeaders(params.data.eihid);
                            if (res) {
                              toast.error(
                                "cannot delete, credit/debit notes exist for this",
                                { autoClose: 5000, containerId: "Main" }
                              );
                              return;
                            } else {
                              setEihId(params.data.eihid);
                              setEihCode(params.data.eihcode);
                              deleteRef.current?.openAlert();
                            }
                          },
                          label: "Delete",
                          Icon: MdDeleteForever,
                          className: `ui ${params.data.eihactive === 2 ? "grey" : "red"} button`,
                          disabled:
                            params.data.eihactive === 2 ||
                            !evInvDeletePermission,
                        };
                      },
                    },
                  ]}
                  content={searchResults}
                  onRowDoubleClicked={cellDoubleClickHandler}
                />
              )}
            </>
          )}
        </div>
      ) : (
        ""
      )}

      <SideDrawer
        open={isDrawerOpen}
        handleDrawerClose={handleDrawerClose}
        head={
          <div className="drawer-header">
            <div style={{ padding: "10px 0 10px 0" }}>
              <h3>Approve Or Reject: {eihCode ? eihCode : "N/A"}</h3>
            </div>
          </div>
        }
        body={
          <JobMonitorEvInvCreation
            editMode={false}
            approvalMode={approvalMode}
            jobId={jobId}
            handleDrawerClose={handleDrawerClose}
            modeObj={mode}
            evInv={evInvCategory}
            evInvDetails={invoiceDetails}
            setUpdateNeeded={setUpdateNeeded}
          />
        }
        style={{ width: "90vw" }}
      />
    </div>
  );
};

export default EvInvApproval;

const styles = `
  .blur-overlay {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
    z-index: 9999; /* Ensure it's on top of everything */
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .blurred {
    filter: blur(5px); /* Blur effect on content */
    pointer-events: none; /* Prevent interaction with blurred content */
  }
`;

document.head.insertAdjacentHTML("beforeend", `<style>${styles}</style>`);
